import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';

import logo from 'images/new_isotipo.png';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: 15,
    right: 0,
    width: '100%',
    justifyContent: 'center'
  },
  text: {
    fontSize: 12,
    alignSelf: 'center'
  },
  logo: {
    width: 15,
    height: 15,
    marginLeft: 10
  }
});

const InvoiceFooter = () => (
  <View style={styles.container}>
    <Text style={styles.text}>Genera más ventas con <Text style={[{color: '#2A4494'}]}>mercately.com</Text></Text>
    <Image style={styles.logo} src={logo} />
  </View>
);

export default InvoiceFooter;
